import React from "react";
import { HotkeysTarget2 } from "@blueprintjs/core";


function YesOrNoHK({accepted, declined, test}) {

    const hotkeys = [
        {
            combo: "s",
            global: true,
            label: "Like",
            onKeyDown: accepted,
        },
        {
            combo: "d",
            global: true,
            label: "Dislike",
            onKeyDown: declined,
        },
        // {
        //     combo: "ctrl + up",
        //     global: true,
        //     label: "Like",
        //     onKeyDown: accepted,
        // },
        // {
        //     combo: "ctrl + down",
        //     global: true,
        //     label: "Dislike",
        //     onKeyDown: declined,
        // },
    ]

    return (
        <HotkeysTarget2 hotkeys={hotkeys}>
                {({ handleKeyDown, handleKeyUp }) => (
                    <div onKeyDown={handleKeyDown} onKeyUp={handleKeyUp}>
                        
                    </div>
                )}
        </HotkeysTarget2>
    )
}

export default YesOrNoHK
